import React, { useEffect, useState, Fragment } from "react";
import {
  Row,
  IconWrapper,
  HorizontalSeparator,
  LogoWrapper,
  TooltipContentWrapper,
  ShortTooltipKey,
  ShortTooltipKeyCus,
  TooltipValueCus
} from "../styled/Tooltip.styled";
import { SiteType } from "../../constants/WebMap";

export default function OperatorTooltip({ type, selectedOperator, data, operatorsPermittedOpSite, operatorsPermittedECSiteET, operatorsPermittedECSitePT }) {
  const [selectedOperatorDetails, setSelectedOperatorDetails] = useState();
  const permittedAnomOps = type === SiteType.Proposed ? operatorsPermittedECSitePT : operatorsPermittedECSiteET;
  const mnoOperatorsETOthers = operatorsPermittedECSiteET?.filter(operator => operator.is_others === true);
  const mnoOperatorsProposedOthers = operatorsPermittedECSitePT?.filter(operator => operator.is_others === true);
  const otherOps = type === SiteType.Proposed ? mnoOperatorsProposedOthers : mnoOperatorsETOthers;

  useEffect(() => {
    setSelectedOperatorDetails();
    if (type === SiteType.EdotcoSite || type === SiteType.Proposed) { // edotco sites Existing T Or Proposed T
      if (data.customersOnSite && data.customersOnSite.length === 1) { // single edotco
        const operator = permittedAnomOps?.find(x =>
          x.operator === data.customersOnSite[0]);
        if (operator) setSelectedOperatorDetails(operator);
      }
    } else { // operator sites
      const operator = operatorsPermittedOpSite?.find(x =>
        x.operator === selectedOperator);
      if (operator) setSelectedOperatorDetails(operator);
    }
  }, [data]);

  const getPermittedOperators = (operators) => {
    let foundOthers = false;
    return operators
      ?.map(op => {
        // First, check if the operator exists in permittedAnomOps
        const foundOperator = permittedAnomOps?.find(item => item.operator === op && item?.is_others === false);
        // If not found in permittedAnomOps, check in otherOps
        if (!foundOperator) {
          const foundOtherOp = otherOps?.find(item => item.operator === op && item?.is_others === true);
          // If found in otherOps and 'Others' is not yet added, set flag and return 'Others'
          if (foundOtherOp && !foundOthers) {
            foundOthers = true;
            return 'Others';
          }
        }

        // If found in permittedAnomOps, return the name of the operator
        return foundOperator ? foundOperator.name : null;
      })
      ?.filter(name => name !== null) // Remove null values
      ?.join(', '); // Join the names with a comma
  }
  return (
    <Fragment>
      <div
        style={{
          minWidth: "250px",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {data && (
          <Fragment>
            <Row style={{ height: "30px", marginTop: '15px' }}>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "flex-start",
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                <IconWrapper>
                  <img
                    src={"/assets/black-antenna.png"}
                    alt="logo1"
                    width="13"
                  />
                </IconWrapper>
                Site
              </div>
              {selectedOperatorDetails?.icon && !selectedOperatorDetails?.isAnonymized ? (
                <div
                  style={{
                    display: "flex",
                    width: "45px",
                    height: "20px",
                    justifyContent: "flex-end",
                  }}
                >
                  <LogoWrapper align={"flex-end"}>
                    <img
                      src={selectedOperatorDetails?.icon}
                      alt="logo1"
                      style={{ maxWidth: "100%", maxHeight: "100%" }}
                      vertical-align="middle"
                    />
                  </LogoWrapper>
                </div>
              ) : selectedOperatorDetails && selectedOperatorDetails?.isAnonymized ? (
                <LogoWrapper
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    width: "58px",
                    height: "30px"
                  }}
                >
                  <h4 style={{
                    color: "#707070",
                    fontSize: "10px",
                    textAlign: "center",
                    lineHeight: "18px",
                    border: "1px solid #016F35",
                    borderRadius: "4px",
                    padding: "4px 5px",
                    display: "inline-block",
                    margin: "0"
                  }}>
                    {selectedOperatorDetails?.name}
                  </h4>

                </LogoWrapper>
              ) : selectedOperatorDetails && selectedOperatorDetails?.is_others ? 
              <LogoWrapper
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                width: "58px",
                height: "30px"
              }}
            >
              <h4 style={{
                color: "#707070",
                fontSize: "10px",
                textAlign: "center",
                lineHeight: "18px",
                border: "1px solid #016F35",
                borderRadius: "4px",
                padding: "4px 5px",
                display: "inline-block",
                margin: "0"
              }}>
                Others
              </h4>
            </LogoWrapper>
              :
                <></>
              }
            </Row>
            <HorizontalSeparator />
            {type === SiteType.EdotcoSite || type === SiteType.Proposed ? (
              <Fragment>
                <Row>
                  <TooltipContentWrapper>
                    <ShortTooltipKey style={{width: '50%'}}>
                      <img
                        src={"/assets/siteRef.png"}
                        alt={"siteRef"}
                        style={{
                          marginRight: "5px",
                          width: '15px',
                          height: '15px'
                        }}
                      />
                      Site Ref
                    </ShortTooltipKey>
                    <TooltipValueCus style={{width: '50%'}}>{data.siteRef || ""}</TooltipValueCus>
                  </TooltipContentWrapper>
                </Row>
                <Row style={{ height: "auto" }}>
                  <TooltipContentWrapper>
                    <ShortTooltipKeyCus>
                      <img
                        src={"/assets/customerOnSite.png"}
                        alt={"customerOnSite"}
                        style={{
                          marginRight: "5px",
                          width: "15px",
                          height: "15px",
                        }}
                      />
                      Customer On Site
                    </ShortTooltipKeyCus>
                    <TooltipValueCus>
                      {getPermittedOperators(data.customersOnSite)}
                    </TooltipValueCus>
                  </TooltipContentWrapper>
                </Row>
                <Row>
                  <TooltipContentWrapper>
                    <ShortTooltipKeyCus>
                      <img
                        src={"/assets/lat.png"}
                        alt={"lat"}
                        style={{
                          marginRight: "5px",
                          width: "15px",
                          height: "15px",
                        }}
                      />
                      Latitude
                    </ShortTooltipKeyCus>
                    <TooltipValueCus>
                      {selectedOperatorDetails?.isAnonymized
                        ? data.latitude
                          ?.toFixed(5)
                          ?.replace(/^\d+/, (match) => 'x'.repeat(match.length))
                          ?.replace(/\.\d+/, (match) => `.${'x'.repeat(match.length - 1)}`)
                        : data.latitude?.toFixed(5)}
                    </TooltipValueCus>  
                  </TooltipContentWrapper>
                </Row>
                <Row>
                  <TooltipContentWrapper>
                    <ShortTooltipKeyCus>
                      <img
                        src={"/assets/lon.png"}
                        alt={"lon"}
                        style={{
                          marginRight: "5px",
                          width: "15px",
                          height: "15px",
                        }}
                      />
                      Longtitude
                    </ShortTooltipKeyCus>
                    <TooltipValueCus>
                      {selectedOperatorDetails?.isAnonymized
                        ? data.longitude
                          ?.toFixed(5)
                          ?.replace(/^\d+/, (match) => 'x'.repeat(match.length))
                          ?.replace(/\.\d+/, (match) => `.${'x'.repeat(match.length - 1)}`)
                        : data.longitude?.toFixed(5)}
                    </TooltipValueCus>
                  </TooltipContentWrapper>
                </Row>
                <Row>
                  <TooltipContentWrapper>
                    <ShortTooltipKeyCus>
                      <img
                        src={"/assets/status.png"}
                        alt={"status"}
                        style={{
                          marginRight: "5px",
                          width: "15px",
                          height: "15px",
                        }}
                      />
                      Status
                    </ShortTooltipKeyCus>
                    <TooltipValueCus>{data.status}</TooltipValueCus>
                  </TooltipContentWrapper>
                </Row>

                <Row>
                  <TooltipContentWrapper>
                    <ShortTooltipKeyCus>
                      <img
                        src={"/assets/structureType.png"}
                        alt={"structureType"}
                        style={{
                          marginRight: "5px",
                          width: "15px",
                          height: "15px",
                        }}
                      />
                      Structure Type
                    </ShortTooltipKeyCus>
                    <TooltipValueCus>{data.structureType}</TooltipValueCus>
                  </TooltipContentWrapper>
                </Row>
                <Row>
                  <TooltipContentWrapper>
                    <ShortTooltipKeyCus>
                      <img
                        src={"/assets/structureCategory.png"}
                        alt={"structureCategory"}
                        style={{
                          marginRight: "5px",
                          width: "15px",
                          height: "15px",
                        }}
                      />
                      Structure Category
                    </ShortTooltipKeyCus>
                    <TooltipValueCus>{data.structureCategory}</TooltipValueCus>
                  </TooltipContentWrapper>
                </Row>
                <Row>
                  <TooltipContentWrapper>
                    <ShortTooltipKeyCus>
                      <img
                        src={"/assets/action.png"}
                        alt={"action"}
                        style={{
                          marginRight: "5px",
                          width: "15px",
                          height: "15px",
                        }}
                      />
                      Action
                    </ShortTooltipKeyCus>
                    <TooltipValueCus>{data.action}</TooltipValueCus>
                  </TooltipContentWrapper>
                </Row>
                {data.action !== "No Action" ? (
                  <>
                    <Row>
                      <TooltipContentWrapper>
                        <ShortTooltipKeyCus>
                          <img
                            src={"/assets/proposedTenants.png"}
                            alt={"proposedTenants"}
                            style={{
                              marginRight: "5px",
                              width: "15px",
                              height: "15px",
                            }}
                          />
                          Proposed Tenants
                        </ShortTooltipKeyCus>
                        <TooltipValueCus>
                          {getPermittedOperators(data.proposedTenants)}
                        </TooltipValueCus>
                      </TooltipContentWrapper>
                    </Row>
                    <Row>
                      <TooltipContentWrapper>
                        <ShortTooltipKeyCus>
                          <img
                            src={"/assets/consolidateSite.png"}
                            alt={"consolidateSite"}
                            style={{
                              marginRight: "5px",
                              width: "15px",
                              height: "15px",
                            }}
                          />
                          Consolidate Site
                        </ShortTooltipKeyCus>
                        <TooltipValueCus>{data.siteName || ""}</TooltipValueCus>
                      </TooltipContentWrapper>
                    </Row>
                  </>
                ) : (
                  <></>
                )}
              </Fragment>
            ) : (
              <Fragment>
                <Row>
                  <TooltipContentWrapper>
                    <ShortTooltipKeyCus>
                      <img
                        src={"/assets/siteRef.png"}
                        alt={"siteRef"}
                        style={{
                          marginRight: "5px",
                          width: "15px",
                          height: "15px",
                        }}
                      />
                      Site Name
                    </ShortTooltipKeyCus>
                    <TooltipValueCus>{data.siteName}</TooltipValueCus>
                  </TooltipContentWrapper>
                </Row>
              </Fragment>
            )}
          </Fragment>
        )}
      </div>
    </Fragment>
  );
}
